import { put, takeLatest, call } from 'redux-saga/effects';

import { requestAndSet, sendToHelium } from 'utils/helpers';

import {
  fetchDenyReasonsRequest,
  describeDenyReasonRequest,
  describeDeniedEntryRequest,
  denyEntryRequest,
  fetchDenyReasonsSuccess,
  describeDenyReasonSuccess,
  describeDeniedEntrySuccess,
  denyEntrySuccess,
  denyApiFailure,
} from '../slices/denySlice';

function* fetchDenyReasonsSaga(
  action: ReturnType<typeof fetchDenyReasonsRequest>,
): Generator {
  const { orgId } = action.payload;
  yield call(
    requestAndSet,
    'listAllDenyReason',
    [orgId],
    fetchDenyReasonsSuccess,
  );
}

function* describeDenyReasonSaga(
  action: ReturnType<typeof describeDenyReasonRequest>,
): Generator {
  const { orgId, reasonId } = action.payload;
  yield call(
    requestAndSet,
    'describeDenyReason',
    [orgId, reasonId],
    describeDenyReasonSuccess,
  );
}

function* describeDeniedEntrySaga(
  action: ReturnType<typeof describeDeniedEntryRequest>,
): Generator {
  const { orgId, visitId } = action.payload;
  yield call(
    requestAndSet,
    'getDenyEntry',
    [orgId, visitId],
    describeDeniedEntrySuccess,
  );
}

function* denyEntrySaga(
  action: ReturnType<typeof denyEntryRequest>,
): Generator {
  try {
    const { orgId, visitId, denyEntry } = action.payload;
    yield call(sendToHelium, 'denyEntry', [orgId, visitId], denyEntry);
    yield put(denyEntrySuccess());
  } catch (error: unknown) {
    const message =
      typeof error === 'object' && error !== null && 'message' in error
        ? String((error as { message?: unknown }).message || '')
        : '';
    yield put(denyApiFailure(message || 'Failed to deny entry'));
  }
}

export function* denySaga() {
  yield takeLatest(fetchDenyReasonsRequest.type, fetchDenyReasonsSaga);
  yield takeLatest(describeDenyReasonRequest.type, describeDenyReasonSaga);
  yield takeLatest(describeDeniedEntryRequest.type, describeDeniedEntrySaga);
  yield takeLatest(denyEntryRequest.type, denyEntrySaga);
}
